import { parse } from 'query-string';

const getOriginFromQuery = (query: string) => {
  const { from } = parse(query);
  return typeof from === 'string' ? from : undefined;
};

export default getOriginFromQuery;
